import commonApi from './commonApi'
import userApi from './userApi'
import businessUserApi from './businessUserApi'
import deviceApi from './deviceApi'
// 模块文件配置
const { VITE_APP_IP, VITE_APP_PORT, VITE_APP_AFTER } = import.meta.env
//接口 后缀
export const prefix = VITE_APP_AFTER
const URL = `${VITE_APP_IP}${VITE_APP_PORT ? ':' + VITE_APP_PORT : ''}`
//接口 基础地址 
export const BASEURL = URL
// 文件预览地址 BASEURL + '/' + FILEPREVIEWURL 
export const FILEPREVIEWURL = `${prefix}/filePreview`
// 服务器上传文件地址 BASEURL + '/' + FILEUPLOADURL 
export const FILEUPLOADURL = `${prefix}/fileUpload`
// 服务器上传文件地址 BASEURL + '/' + FILEUPLOADURL
export const FILEUPLOADURLHEAD = `${prefix}/v1/op/currentUserLogo`
// 服务器下载文件
export const FILEDOWNLOAD = `${BASEURL}${prefix}/v1/fileDownload`
// 服务器下载模版
export const FILEDOWNLOD = `${BASEURL}${prefix}/v1/template/download`
// 设备导出
export const DEVICEEXCELEXPORT = `${BASEURL}${prefix}/v1/op/deviceExcelExport`
export const SPAREPARTEXCELEXPORT = `${BASEURL}${prefix}/v1/op/sparePartExcelExport`



// 接口集合
export const APIS = [
  ...commonApi,
  ...userApi,
  ...businessUserApi,
  ...deviceApi
]
